<template>
  <div class="py-5 space-y-1 text-sm sm:text-base text-white footer-bg flex items-center">
    <div class="max-w-7xl mx-auto pt-1">
    農業部生物多樣性研究所版權所有 <br class="sm:hidden">© Taiwan Biodiversity Research Institute
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.footer-bg{
  height: 90px;
  background-color: #66849C;
}
</style>
